import { useQuery } from "@tanstack/react-query"
import { useMolecule } from "bunshi/react"
import { UserCollectionItemsMoleculeReatom } from "./user-collection-items-molecule.reatom"

// Counter use the same query as list view to share the cache and reduce number of requests
export const useCollectionItemsOwnedByUserCountReatom = () => {
  const { userCollectionItemsCountQueryParams } = useMolecule(
    UserCollectionItemsMoleculeReatom,
  )
  const queryParams = userCollectionItemsCountQueryParams()
  const query = useQuery(queryParams)

  return query.data
}
